export const contract_broad_types = {
    list: [
        {
            title: '存货类合同',
            key: 'stock'
        },
        {
            title: '非存货类合同',
            key: 'stockless'
        },
        {
            title: '销售课程（带存货）',
            key: 'course_with_stock'
        },
        {
            title: '销售课程（不带存货）',
            key: 'course_without_stock'
        },
        {
            title: '销售实体（带存货）',
            key: 'real_entity'
        },
        {
            title: '虚拟合同',
            key: 'virtual'
        }
    ],
    hash: function() {
        return this.list.reduce((total, item) => {
            total[item.key] = item
            return total
        }, {})
    },
    getName(key) {
        const hash = this.hash()
        if (!hash[key]) {
            return '-'
        }
        return this.hash()[key].title
    }
}


export const balance_types = {
    list: [
        {
            title: '支出类',
            key: 'expense'
        },
        {
            title: '收入类',
            key: 'income'
        },
        {
            title: '有收有支',
            key: 'expense_income'
        },
        {
            title: '无收无支',
            key: 'costless'
        }
    ],
    hash: function() {
        return this.list.reduce((total, item) => {
            total[item.key] = item
            return total
        }, {})
    },
    getName(key) {
        const hash = this.hash()
        if (!hash[key]) {
            return '-'
        }
        return this.hash()[key].title
    }
}